module.exports = __webpack_public_path__ + "img/Delete-popup-icon.fab4db36.svg";